import {
  Box,
  Container,
  Stack,
  Typography,
  useTheme,
  Link as MuiLink,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { GradientBorderBox } from "../../../Components";
import Lists from "./Lists";
import { useLocation } from "react-router-dom";
import {
  useGetAboutQuery,
  useGetBranchesQuery,
} from "../../../Store/Slices/rtk";

export default function Footer() {
  const theme = useTheme();
  const location = useLocation().pathname;
  const isMobile = useMediaQuery("(max-width:900px)");
  const { data, status } = useGetAboutQuery();
  const { data: branchData } = useGetBranchesQuery();

  const footerVisibility = location == "/cart" ? true : false;
  const helpfulLinks = [
    { title: "درباره ما", route: "contact-us" },
    { title: "قوانین و مقررات", route: "rules" },
    { title: "بلاگ", route: "blogs" },
    { title: "راهنمای خرید", route: "guide" },
    // { title: "پشتیبانی", route: "contact-us" },
  ];
  const shopLinks = [
    { title: "خرید آیفون ۱۷", route: "/" },
    { title: "خرید آیفون ۱۷ پرومکس", route: "/" },
    { title: "خرید آیفون ۱۷ پرو", route: "/" },
    { title: "ایرپاد پرو۲", route: "/" },
    { title: "سامسونگ s23 ", route: "/" },
    { title: "شیائومی", route: "/" },
  ];

  return (
    <>
      <Container
        maxWidth={"xxl"}
        sx={{
          mt: "10rem",
          mb: "0",
          display: footerVisibility ? "none" : "block",
        }}
      >
        {/* Main Footer */}
        <Stack sx={{ p: "2rem 1rem", position: "relative", width: "100%" }}>
          {/* Content Stack */}
          <Stack
            direction={{ xs: "column-reverse", lg: "row" }}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              gap: "4rem",
              position: "relative",
              zIndex: "10",
              py: "2rem",
            }}
          >
            {/* info*/}
            <Stack sx={{ width: { xs: "100%", lg: "25%" } }}>
              <Typography
                sx={{ textAlign: "justify", mb: "2rem", fontSize: ".9rem" }}
              >
                {branchData?.data?.branchs?.[0]?.desc}
              </Typography>
              <Typography
                sx={{
                  color: theme.palette.primary.main,
                  fontWeight: "500",
                  textAlign: "center",
                  mb: "1rem",
                }}
              >
                {branchData?.data?.branchs?.[0]?.address}
              </Typography>
              <MuiLink
                href={`tel:${branchData?.data?.branchs?.[0]?.phone_number?.[0]}`}
                sx={{
                  textAlign: "center",
                  fontWeight: "500",
                  textDecoration: "none",
                  color: theme.palette.text.primary,
                }}
              >
                {branchData?.data?.branchs?.[0]?.phone_number?.[0] || "-"}
              </MuiLink>
            </Stack>
            {/* Social , Icon */}
            <Stack direction={{ xs: "column-reverse", lg: "column" }}>
              {/* Icon */}
              <Box
                sx={{
                  height: { xs: "250px", lg: "380px" },
                  width: { xs: "180px", lg: "250px" },
                }}
              >
                <img
                  style={{ width: "100%", height: "100%" }}
                  src="/Media/Layout/MainLayout/Footer/Union.png"
                  alt="nimobile footer Icon"
                />
              </Box>
              {/* Social Icons */}
              <Stack
                direction={"row"}
                sx={{ alignItems: "center", justifyContent: "center" }}
              >
                {/* Telegram */}
                {/* <MuiLink
                  href={data?.data?.links?.telegram}
                  target={"_blank"}
                  sx={{ width: "60px", height: "60px" }}
                >
                  <img
                    style={{ width: "100%", height: "100%" }}
                    src="/Media/Layout/MainLayout/Footer/telegram.png"
                    alt="telegram icon"
                  />
                </MuiLink> */}
                {/* Instagram */}
                <MuiLink
                  href={data?.data?.links?.instagram}
                  target={"_blank"}
                  sx={{
                    width: "60px",
                    height: "60px",
                    ":hover": { rotate: "20deg" },
                    transition: "all .3s",
                    borderRadius: "16px",
                  }}
                >
                  <img
                    style={{ width: "100%", height: "100%" }}
                    src="/Media/Layout/MainLayout/Footer/instagram.png"
                    alt="telegram icon"
                  />
                </MuiLink>
                {/* telegram */}
                <MuiLink
                  href={data?.data?.links?.telegram}
                  target={"_blank"}
                  sx={{
                    width: "60px",
                    height: "60px",
                    ":hover": { rotate: "20deg" },
                    transition: "all .3s",
                    borderRadius: "16px",
                  }}
                >
                  <img
                    style={{ width: "100%", height: "100%" }}
                    src="/Media/Layout/MainLayout/Footer/telegram.png"
                    alt="telegram icon"
                  />
                </MuiLink>
              </Stack>
            </Stack>
            {/* Lists */}
            <Stack direction={"row"} sx={{ gap: "1.5rem", minWidth: "20%" }}>
              <Lists helpfulLinks={helpfulLinks} shopLinks={shopLinks} />
            </Stack>
            {/* Circle Gradient */}
            {!isMobile && (
              <GradientBorderBox
                bgGrad={`linear-gradient(
    90deg,
    ${theme.palette.background.white} -30%,
    ${theme.palette.background.default} 45%,
    ${theme.palette.background.default} 55%,
     ${theme.palette.primary.main} 130%
  )`}
                radius="40rem"
              />
            )}
          </Stack>
          {/* Main Gradient */}
          <GradientBorderBox
            bgGrad={`linear-gradient(
    90deg,
    ${theme.palette.primary.main} 0%,
    ${theme.palette.background.default} 35%,
    ${theme.palette.background.default} 65%,
     ${theme.palette.background.white} 100%
  )`}
            radius="2.5rem"
          />
          {/* Circle Images left Center */}
          <Stack
            sx={{
              position: "absolute",
              width: "100%",
              height: "900px",
              bottom: "0%",
              // bgcolor: "black",
              // overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                bottom: "0%",
                left: "0%",
                transform: "translate(-40% , 30%)",
                zIndex: "-10",
                width: { xs: "250px", md: "350px" },
                height: { xs: "250px", md: "350px" },
                opacity: ".7",
              }}
            >
              <img
                style={{ width: "100%", height: "100%" }}
                src="/Media/Circles/circle.svg"
                alt="circle images"
              />
            </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: "10%",
                right: "0%",
                transform: "translate(40% , 0%)",
                zIndex: "-10",
                width: { xs: "150px", md: "220px" },
                height: { xs: "150px", md: "220px" },
                opacity: ".7",
              }}
            >
              <img
                style={{ width: "100%", height: "100%" }}
                src="/Media/Circles/circle.svg"
                alt="circle images"
              />
            </Box>
          </Stack>
        </Stack>
        <Stack sx={{ mt: "1rem", mb: "2.5rem" }}>
          <Typography
            component={"a"}
            href={"https://vira-tec.ir/"}
            target="_blank"
            color="primary"
            sx={{
              textAlign: "center",

              textDecoration: "none",
              display: "inline-block",
              color: "text.lowOpacity",
              mx: "auto",
              transition: "all .3s",
              ":hover": {
                color: theme.palette.primary.main,
              },
            }}
          >
            {new Date().getFullYear()} © کلیه حقوق مادی و معنوی این وب‌سایت
            متعلق به نی موبایل می‌باشد.
            <br />
            طراحی و تولید ویرا آروند آریا
          </Typography>
        </Stack>
      </Container>
    </>
  );
}
